import classNames from "classnames";
import React from "react";

import css from "../../side_panel_rows.module.scss";
import { ShowAllBookingsIcon } from "../show_all_bookings_icon";

interface SidePanelRowActionsProps {
  className?: string;
  showAllBookingsAction: {
    isAllBookingsModeEnabled: boolean;
    handleAllBookingsModeChange: (value: boolean) => void;
  };
}

export const SidePanelRowActions = ({
  className,
  showAllBookingsAction
}: SidePanelRowActionsProps): JSX.Element => {
  const { isAllBookingsModeEnabled, handleAllBookingsModeChange } = showAllBookingsAction;
  return (
    <div
      className={classNames(css.sidePanelRowActions, className, {
        [css.sidePanelRowActionsVisible]: isAllBookingsModeEnabled,
        [css.sidePanelRowActionsHidden]: !isAllBookingsModeEnabled
      })}
    >
      <ShowAllBookingsIcon
        className={classNames(css.sidePanelRowAction, {
          [css.sidePanelRowActionVisible]: isAllBookingsModeEnabled
        })}
        isEnabled={isAllBookingsModeEnabled}
        onToggle={handleAllBookingsModeChange}
      />
    </div>
  );
};
